/* eslint-disable no-param-reassign */
// import TX_SHARE from '@tencent/h5-share';
import { browser } from '../ws-hybrid';
import { dom, ajax, load } from '../ws-util';

const APP_ID_WX = 'wxc1fc5d34fc24f53b';
const APP_ID_SQ = '1101083114';
const wsShareSdk = '//isee.weishi.qq.com/iseecdn/static/js/wesee-h5-share.js';

/**
 * weishi share module
 * @class WsShare
 */
class WsShare {
  constructor() {
    this.shareIns = null;
  }

  /**
   * initial share config
   * @param {Object} options share config option
   */
  async saiyan(options) {
    if (!this.shareIns) {
      let wxConfig;
      if (browser.client === 'wx') {
        try {
          wxConfig = await new Promise(res => ajax.request({
            url: '//activity.qzone.qq.com/fcg-bin/fcg_act_weixin_jssdk_sig',
            method: 'jsonp',
            // dataType: 'jsonp',
            params: {
              url: window.location.href.replace(window.location.hash, ''),
              appid: APP_ID_WX,
            },
            // success(result) {
            //   return JSON.stringify(result);
            // },
          })
            .then((_) => {
              console.log('wx sig then', _);
              res(_.data);
            })
            .catch((e) => {
              console.log('wx sig catch', e);
            }));
          // .always((_) => {
          //   console.log('wx sig always', _);
          //   res(_);
          // }));
        } catch (err) {
          console.log(err);
        }

        console.log('wxConfig', wxConfig);
        wxConfig = wxConfig || {};

        Object.assign(wxConfig, {
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'showOptionMenu',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
          ],
        });
      }
      this.shareIns = await new Promise((res) => {
        if (window.H5_SHARE) {
          res(new window.H5_SHARE());
        } else {
          load.loadJs(wsShareSdk, () => {
            res(new window.H5_SHARE());
          });
        }
      });
      this.shareIns.options = {
        wxConfig,
        uiState: {
          isPreview: false,
          disableWSCustomBtn: true,
          shareConfig: {
            qq: true,
            qz: !(
              browser.client === 'ws' && browser.platform === 'android'
            ),
            wx: true,
            timeLine: true,
            weibo: false,
          },
          handleIconClick: null,
          title: '',
          isPreviewBase64: false,
          handlePreviewClick: null,
        },
      };
    }
    options.shareInfo = options.shareInfo || {};
    // 对微视常用结构最一些转换
    this.formatFromWeishi(options.shareInfo);

    Object.assign(this.shareIns.options, options);
    await this.shareIns.config(this.shareIns.options);

    return this.shareIns;
  }

  /**
   * 解析分享数据
   * @param {Object} svrShareInfo server return info
   */
  getShareFromSvr(svrShareInfo) {
    const shareBody = (svrShareInfo.body_map && svrShareInfo.body_map['1']) || {};
    const shareBodyWB = (svrShareInfo.body_map && svrShareInfo.body_map['4']) || {};
    return {
      title: shareBody.title,
      summary: shareBody.desc || '来微视，发现更有趣的人',
      pic: shareBody.image_url,
      url: svrShareInfo.jump_url,
      weibo_title: shareBodyWB.title,
      weibo_summary: shareBodyWB.desc,
      weibo_pic_url: shareBodyWB.image_url,
    };
  }

  /**
   * 把分享的url转化成schema用于跳转
   * @param {String} url
   * @returns {String}
   */
  urlToSchema(url) {
    const playMath = url.match(/.*\/(play|feed)\/([0-9a-zA-Z]*)/);
    if (playMath && playMath[2]) {
      return `weishi://feed?feed_id=${playMath[2]}`;
    }

    const personMath = url.match(/.*\/(personal)\/([0-9a-zA-Z]*)/);
    if (personMath && personMath[2]) {
      return `weishi://profile?person_id=${personMath[2]}`;
    }

    const topicMath = url.match(/.*\/(topic)\/([0-9a-zA-Z]*)/);
    if (topicMath && topicMath[2]) {
      return `weishi://topic?topic_id=${topicMath[2]}`;
    }

    return 'weishi://main?goto=recommend';
  }

  /**
   * 格式化/兼容不同写法
   * @param {Object} shareInfo share information
   */
  formatFromWeishi(shareInfo) {
    // 兼容各种写法。。。
    shareInfo.link = shareInfo.link
      || shareInfo.jump_url
      || shareInfo.url
      || window.location.href;
    shareInfo.imgUrl = shareInfo.imgUrl || shareInfo.pic_url || shareInfo.pic;
    shareInfo.title = shareInfo.title || document.title;
    shareInfo.desc = shareInfo.desc || shareInfo.summary || document.title;
    if (!shareInfo.link) {
      shareInfo.type = 'link';
      shareInfo.link = window.location.href;
    }
    // 处理特殊逻辑
    // shareInfo.link = shareInfo.url = share.handleSpecial(shareInfo.link);
    // 塞一些业务专用的信息
    const schema = this.urlToSchema(shareInfo.link);
    Object.assign(
      shareInfo,
      browser.client === 'wx'
        ? {
          appid: APP_ID_WX,
        }
        : {
          appid: APP_ID_SQ,
          sourceName: '微视',
          src_iconUrl:
              'http://qzonestyle.gtimg.cn/aoi/sola/20180420174331_y8WdLUUoxL.png',
          src_action: 'plugin',
          src_actionData: schema,
        },
    );
  }

  /**
   * 包含 `/weishi/feed/` 的链接特殊处理
   * @param {String} link link
   */
  handleSpecial(link) {
    if (~link.indexOf('/weishi/feed/')) {
      const attachExg = window.location.href.match(/attach=([^&]*)/);
      let attach = (attachExg && attachExg[1]) || '';

      if (!~attach.indexOf('cp_reserves16')) {
        attach += `${attach ? '|' : ''}cp_reserves16_2`;
      }
      link = window.location.href.replace(
        /attach=[^&]*/,
        `attach=${encodeURIComponent(attach)}`,
      );
    }
    return link;
  }

  /**
   * 添加分享 meta
   * @param {String} title title
   * @param {String} description description
   * @param {String} image image
   * @param {String} url url
   */
  addShareMeta(title, description, image, url) {
    if (document.querySelectorAll('meta[name=share_title]').length) {
      document.querySelector('meta[name=share_title]').setAttribute('content', title);
      document.querySelector('meta[name=share_description]').setAttribute('content', description);
      document.querySelector('meta[name=share_image]').setAttribute('content', image);
      document.querySelector('meta[name=share_url]').setAttribute('content', url);
    } else {
      const el = document.querySelector('head');
      el.appendChild(dom.str2dom('<meta property="og:type" content="website" />'));
      el.appendChild(dom.str2dom(`<meta name="share_title" property="og:title" content="${title}"/>`));
      el.appendChild(dom.str2dom(`<meta name="share_description" property="og:description" content="${description}" />`));
      el.appendChild(dom.str2dom(`<meta name="share_image" property="og:image" content="${image}"/>`));
      el.appendChild(dom.str2dom(`<meta name = "share_url" property = "og:url" content = "${url}" />`));
    }
  }
}

export default new WsShare();
